<template>
  <div>
    <BaseTitle :title="$t(edit ? 'content.class_edit' : 'content.class_create')" />

    <!-- Class Information -->
    <v-card class="pa-8 mb-6">
      <h3 class="app-section-title">{{ $t('content.class_name') }}</h3>
      <v-row>
        <v-col cols="12" md="3" class="py-0">
          <form-group :name="$t('form.schoolyear')" :validator="$v.form.yearPeriode">
            <template slot-scope="{ attrs }">
              <v-text-field
                v-model="form.yearPeriode"
                v-bind="attrs"
                :label="$t('form.schoolyear')"
                @input="$v.form.yearPeriode.$touch()"
                @blur="$v.form.yearPeriode.$touch()"
              />
            </template>
          </form-group>
        </v-col>
        <v-col cols="12" md="3" class="py-0">
          <form-group :name="$t('content.class_level')" :validator="$v.form.gradeId">
            <template slot-scope="{ attrs }">
              <v-select
                v-model="form.gradeId"
                v-bind="attrs"
                item-value="gradeId"
                item-text="name"
                :items="class_level"
                :label="$t('content.class_level')"
                @change="getStudents"
              />
            </template>
          </form-group>
        </v-col>
        <v-col cols="12" md="3" class="py-0">
          <form-group :name="$t('content.class_sort')" :validator="$v.form.name">
            <template slot-scope="{ attrs }">
              <v-text-field
                v-model="form.name"
                v-bind="attrs"
                :label="$t('content.class_sort')"
                @input="$v.form.name.$touch()"
                @blur="$v.form.name.$touch()"
              />
            </template>
          </form-group>
        </v-col>
        <v-col cols="12" md="3" class="py-0">
          <form-group :name="$t('form.status')" :validator="$v.form.status">
            <template slot-scope="{ attrs }">
              <v-select :items="status" :label="$t('form.status')" v-bind="attrs" v-model="form.status" width="100">
                <template #item="{item}">
                  {{ $t(item.text) }}
                </template>
                <template #selection="{item}">
                  {{ $t(item.text) }}
                </template>
              </v-select>
            </template>
          </form-group>
        </v-col>
      </v-row>
    </v-card>

    <!-- Course List -->
    <v-card class="pa-8 mb-6">
      <div class="d-flex align-items-center justify-space-between">
        <h3 class="app-section-title mb-6">{{ $t('content.course_list') }}</h3>

        <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2" @click="addCourse">{{ $t('add') }}</v-btn>
      </div>
      <v-data-table :headers="tableHeader" :loading="table.loading" :items="form.courses" hide-default-footer disable-pagination class="table-custom">
        <template #item.teachers="{ item }">
          <ul>
            <li v-for="items in item.teachers.filter(items => items.status == true)" v-bind:key="items.classroomId">{{ items.fullName }}</li>
          </ul>
        </template>
        <template #item.students="{ item }">
          <span class="primary--text" @click="onShowItem(item.students)" style="cursor: pointer"
            >{{ item.students.filter(items => items.studentStatus == true).length }} {{ $t('content.students') }}</span
          >
        </template>
        <template #item.actions="{ item }">
          <v-btn text @click="deleteItemCourse(item, form.courses.indexOf(item))" class="mr-1"><svg-icon icon="delete" class="red--text"/></v-btn>
          <v-btn text @click="editItemCouse(item, form.courses.indexOf(item))"><svg-icon icon="edit" class="primary--text"/></v-btn>
        </template>
        <template #no-data><NoData /></template>
      </v-data-table>
    </v-card>

    <!-- Button Controls -->
    <div class="d-flex justify-end align-center pa-8">
      <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="backToList">{{ $t('cancel') }}</v-btn>
      <v-btn color="primary" class="btn-primary-custom" :loading="loading" type="submit" @click="submit()">{{ $t(edit ? 'save' : 'submit') }}</v-btn>
    </div>

    <!-- Dialog Student -->
    <v-dialog v-model="dialogStudent" persistent max-width="1000">
      <v-card class="pa-6">
        <div class="d-flex align-center justify-space-between">
          <h3 class="app-section-title mb-6">{{ $t('content.student_list') }}</h3>
          <div>
            <v-text-field v-model="search" :label="$t('search')">
              <template #prepend-inner>
                <svg-icon icon="ic-search" class="primary--text mr-3" />
              </template>
            </v-text-field>
          </div>
        </div>
        <v-data-table
          :headers="tableHeader1"
          :loading="table.loading"
          :items="listStudent"
          hide-default-footer
          class="table-custom scroll"
          :search="search"
          disable-pagination
        >
          <template #no-data><NoData /></template>
        </v-data-table>
        <div class="d-flex justify-end align-center mt-4">
          <v-btn color="primary" class="btn-primary-custom" outlined @click="cancelViewStudent">{{ $t('close') }}</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Dialog Course -->
    <v-dialog v-model="dialogCourse" persistent width="900">
      <v-card>
        <v-card-title class="white--text headline secondary">
          {{ $t('content.add_course') }}
        </v-card-title>
        <div class="pa-8">
          <form-group :name="$t('content.course_name')" :validator="$v.doubleCourse">
            <template slot-scope="{ attrs }">
              <v-select
                v-model="doubleCourse"
                :items="course_name"
                item-text="name"
                item-value="courseId"
                :label="$t('content.course_name')"
                v-bind="attrs"
                persistent-hint
                return-object
              />
            </template>
          </form-group>
          <form-group :name="$t('form.status')" :validator="$v.statusCourse">
            <template slot-scope="{ attrs }">
              <v-select :items="status" :label="$t('form.status')" v-bind="attrs" v-model="statusCourse" width="100">
                <template #item="{item}">
                  {{ $t(item.text) }}
                </template>
                <template #selection="{item}">
                  {{ $t(item.text) }}
                </template>
              </v-select>
            </template>
          </form-group>
          <div class="d-flex align-center justify-space-between">
            <h3 class="app-section-title mb-6">{{ $t('content.student_list') }}</h3>
            <div>
              <v-text-field v-model="search" :label="$t('search')">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
            </div>
          </div>
          <v-data-table
            :headers="tableHeader1"
            :loading="table.loading"
            :items="students"
            show-select
            item-key="studentId"
            v-model="listStudent"
            hide-default-footer
            class="table-custom scroll"
            :search="search"
            disable-pagination
          >
            <template #no-data><NoData /></template>
          </v-data-table>
          <br />
          <h3 class="app-section-title mb-6">{{ $t('roles.teacher') }}</h3>
          <v-row>
            <v-col cols="12" md="6" class="py-0 mb-2">
              <div class="move-list">
                <div class="move-list-title">
                  <v-text-field dense filled dark rounded hide-details :label="$t('content.teacher_list')" single-line v-model="searchTeacherList">
                    <template #append>
                      <v-icon color="white">mdi-magnify</v-icon>
                    </template>
                  </v-text-field>
                </div>
                <div class="move-list-content">
                  <ul v-if="filterTeacherList.length">
                    <li v-for="teach in filterTeacherList" :key="teach.userId">
                      {{ teach.fullName }}
                      <v-btn text @click="addTeacher(teach.userId, teach.fullName)"><svg-icon icon="mobile-plus" class="primary--text"/></v-btn>
                    </li>
                  </ul>
                  <NoData v-else />
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <div class="move-list">
                <div class="move-list-title">
                  <v-text-field dense filled dark rounded hide-details :label="$t('content.teacher_class')" single-line v-model="searchTeacherClass">
                    <template #append>
                      <v-icon color="white">mdi-magnify</v-icon>
                    </template>
                  </v-text-field>
                </div>
                <div class="move-list-content">
                  <ul>
                    <ul v-if="filterTeacher.length">
                      <li v-for="(data, index) in filterTeacher" :key="index">
                        {{ data.fullName }}
                        <v-btn @click="backTeacher(data)" text><svg-icon icon="delete" class="red--text"/></v-btn>
                      </li>
                    </ul>
                    <NoData v-else />
                  </ul>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="backTeacherTemp()">{{ $t(edit ? 'back' : 'cancel') }}</v-btn>
          <v-btn @click="addTeacherTemp()" color="primary" :loading="loading" class="btn-primary-custom" type="submit">{{
            $t(edit ? 'save' : 'submit')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Course Edit -->
    <v-dialog v-model="dialogCourseEdit" persistent width="900">
      <v-card>
        <v-card-title class="white--text headline secondary">
          {{ $t('content.edit_course') }}
        </v-card-title>
        <div class="pa-8">
          <form-group :name="$t('content.course_name')">
            <v-select
              v-model="doubleCourse"
              :items="course_name"
              item-text="name"
              item-value="courseId"
              :label="$t('content.course_name')"
              persistent-hint
              return-object
              single-line
            ></v-select>
          </form-group>
          <form-group :name="$t('form.status')">
            <template slot-scope="{ attrs }">
              <v-select :items="status" :label="$t('form.status')" v-bind="attrs" v-model="statusCourse" width="100">
                <template #item="{item}">
                  {{ $t(item.text) }}
                </template>
                <template #selection="{item}">
                  {{ $t(item.text) }}
                </template>
              </v-select>
            </template>
          </form-group>
          <div class="d-flex align-center justify-space-between">
            <h3 class="app-section-title mb-6">{{ $t('content.student_list') }}</h3>
            <div>
              <v-text-field v-model="search" :label="$t('search')">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
            </div>
          </div>
          <v-data-table
            :headers="tableHeader1"
            :loading="table.loading"
            :items="students"
            show-select
            item-key="studentId"
            v-model="listStudent"
            hide-default-footer
            class="table-custom scroll"
            :search="search"
            disable-pagination
          >
            <template #no-data><NoData /></template>
          </v-data-table>
          <br />
          <h3 class="app-section-title mb-6">{{ $t('roles.teacher') }}</h3>
          <v-row>
            <v-col cols="12" md="6" class="py-0 mb-2">
              <div class="move-list">
                <div class="move-list-title">
                  <v-text-field dense filled dark rounded hide-details :label="$t('content.teacher_list')" single-line v-model="searchTeacherList">
                    <template #append>
                      <v-icon color="white">mdi-magnify</v-icon>
                    </template>
                  </v-text-field>
                </div>
                <div class="move-list-content">
                  <ul>
                    <ul v-if="filterTeacherList.length">
                      <li v-for="teach in filterTeacherList" :key="teach.userId">
                        {{ teach.fullName }}
                        <v-btn text @click="addTeacherEdit(teach.userId, teach.fullName)"><svg-icon icon="mobile-plus" class="primary--text"/></v-btn>
                      </li>
                    </ul>
                    <NoData v-else />
                  </ul>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <div class="move-list">
                <div class="move-list-title">
                  <v-text-field
                    dense
                    filled
                    dark
                    rounded
                    hide-details
                    :label="$t('content.teacher_class')"
                    single-line
                    v-model="searchTeacherClassEdit"
                  >
                    <template #append>
                      <v-icon color="white">mdi-magnify</v-icon>
                    </template>
                  </v-text-field>
                </div>
                <div class="move-list-content">
                  <ul>
                    <ul>
                      <li v-for="(data, index) in coursesFilter" :key="index">
                        {{ data.fullName }}
                        <v-btn @click="backTeacherEdit(data, index)" text><svg-icon icon="delete" class="red--text"/></v-btn>
                      </li>
                    </ul>
                  </ul>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="backEdit()">{{ $t(edit ? 'back' : 'cancel') }}</v-btn>
          <v-btn @click="addBackTeacherTempEdit()" color="primary" :loading="loading" class="btn-primary-custom" type="submit">{{
            $t(edit ? 'save' : 'submit')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import NoData from '@/components/table/NoData';
import wordPunctuation from '@/validators/wordPunctuation';

export default {
  name: 'ClassCreateEdit',
  components: {
    BaseTitle,
    NoData
  },
  computed: {
    ...mapGetters({
      items: 'SchoolClass/items',
      teacher: 'SchoolClass/teacher',
      course_name: 'SchoolClass/course',
      status: 'Reference/itemStatus',
      years: 'Reference/itemSchoolYears',
      user: 'Auth/user'
    }),
    filterTeacher() {
      if (this.searchTeacherClass) {
        return this.cour.teacher.filter(item => {
          return item.fullName.startsWith(this.searchTeacherClass);
        });
      } else {
        return this.cour.teacher;
      }
    },
    filterTeacherList() {
      if (this.searchTeacherList) {
        return this.teacher.filter(item => {
          return item.fullName.startsWith(this.searchTeacherList);
        });
      } else {
        return this.teacher;
      }
    },
    coursesFilter() {
      if (this.searchTeacherClassEdit) {
        return this.form.courses[this.keycourses].teachers.filter(item => {
          return item.fullName.startsWith(this.searchTeacherClassEdit) && item.status == true;
        });
      } else {
        if (this.keycourses !== null && this.keycourses !== '') {
          return this.form.courses[this.keycourses].teachers.filter(item => {
            return item.status == true;
          });
        } else {
          return null;
        }
      }
    },
    tableHeader() {
      return [
        { text: this.$t('table.name'), value: 'name' },
        { text: this.$t('roles.teacher'), value: 'teachers', sortable: false },
        { text: this.$t('content.total_student'), value: 'students', sortable: false },
        { text: this.$t('table.action'), value: 'actions', width: 180, sortable: false }
      ];
    },
    tableHeader1() {
      return [
        { text: this.$t('table.name'), value: 'fullName' },
        { text: 'NIS', value: 'identityNumber' }
      ];
    }
  },
  watch: {
    user: {
      deep: true,
      immediate: true,
      handler: function(value) {
        this.form.schoolId = value.schoolId;
      }
    }
  },
  validations: {
    doubleCourse: { required },
    statusCourse: { required },
    form: {
      yearPeriode: { required, wordPunctuation },
      gradeId: { required },
      name: { required, maxLength: maxLength(70) },
      status: { required },
      schoolId: { required }
    }
  },
  data: () => ({
    dialogStudent: false,
    dialogCourse: false,
    dialogCourseEdit: false,
    edit: false,
    loading: false,
    searchTeacherClass: '',
    searchTeacherList: '',
    searchTeacherClassEdit: '',
    search: '',
    doubleCourse: '',
    keycourses: '',
    listStudent: [],
    students: [],
    students_edit: [],
    statusCourse: '',
    class_level: [],
    form: {
      classroomId: '',
      yearPeriode: '',
      gradeId: '',
      name: '',
      status: '',
      schoolId: '',
      students: [],
      courses: []
    },
    cour: {
      teacher: []
    },
    table: []
  }),
  methods: {
    getData() {
      this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.id).then(res => {
        Object.keys(this.form).forEach(form => (this.form[form] = res[form]));
        this.hasLoad = true;
      });
    },
    getLevel() {
      this.table.loading = true;
      this.$store
        .dispatch('Reportschool/fetchClassLevel')
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .then(res => (this.class_level = res))
        .finally(() => (this.table.loading = false));
    },
    onShowItem(item) {
      this.dialogStudent = true;
      // console.info(item);
      var filter = item.filter(items => items.studentStatus == true);
      this.listStudent = filter;
    },
    getCourse() {
      this.table.loading = true;

      if (this.$route.params.id) {
        this.$store
          .dispatch('SchoolClass/fetchCourseEdit', this.$route.params.id)
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
          .finally((this.table.loading = false));
      } else {
        this.$store
          .dispatch('SchoolClass/fetchCourse', this.form)
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
          .finally((this.table.loading = false));
      }
    },
    getCoursesRefresh() {
      this.table.loading = true;
      this.$store
        .dispatch('SchoolClass/fetchCourse', this.form)
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally((this.table.loading = false));
    },
    getStudentsRefresh() {
      if (this.form.gradeId) {
        this.$store
          .dispatch('SchoolClass/fetchStudent', this.form.gradeId)
          .then(res => (this.students = res))
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
          .finally((this.table.loading = false));
      }
    },
    getStudentsRefreshEdit() {
      if (localStorage.getItem('gradeId')) {
        this.$store
          .dispatch('SchoolClass/fetchStudent', localStorage.getItem('gradeId'))
          .then(res => (this.students = res))
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
          .finally((this.table.loading = false));
      }
    },
    getStudents() {
      this.form.courses = [];
      if (!this.$route.params.id) {
        this.getCoursesRefresh();
      }
      if (this.form.gradeId) {
        this.$store
          .dispatch('SchoolClass/fetchStudent', this.form.gradeId)
          .then(res => (this.students = res))
          .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
          .finally((this.table.loading = false));
      }
    },
    getTeacher() {
      this.$store.dispatch('SchoolClass/fetchTeacher').catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    addCourse() {
      localStorage.removeItem('gradeId');
      if (this.form.gradeId) {
        this.getStudentsRefresh();
        this.dialogCourse = true;
      } else {
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('alert.alert_class_add') });
      }
    },
    addTeacherTemp() {
      const validators = [this.$v.doubleCourse, this.$v.statusCourse];
      validators.forEach(v => v.$touch());

      const hasInvalid = validators.some(v => v.$invalid);
      if (hasInvalid) {
        this.$nextTick(() => {
          document.querySelector('.v-dialog')?.scrollTo({ top: 0, behavior: 'smooth' });
        });
        return;
      }

      if (
        this.doubleCourse.name &&
        typeof this.cour.teacher !== 'undefined' &&
        this.cour.teacher.length > 0 &&
        this.listStudent.filter(items => items.studentStatus == true).length > 0
      ) {
        this.form.courses.push({
          courseId: this.doubleCourse.courseId,
          status: this.statusCourse,
          name: this.doubleCourse.name,
          teachers: this.cour.teacher,
          students: this.listStudent
        });
        this.$store.commit('SchoolClass/filterCourse', this.doubleCourse.courseId);
        this.dialogCourse = false;
        this.cour.courseId = '';
        this.cour.teacher = [];
        this.listStudent = [];
        this.statusCourse = '';
        this.doubleCourse = {};
        this.getTeacher();
      } else if (
        this.cour.teacher.length == 0 &&
        !this.doubleCourse.name &&
        this.listStudent.filter(items => items.studentStatus == true).length == 0 &&
        !this.statusCourse
      ) {
        this.dialogCourse = true;
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('alert.alert_add_class') });
      } else if (
        this.cour.teacher.length == 0 &&
        this.doubleCourse.name &&
        this.listStudent.filter(items => items.studentStatus == true).length > 0 &&
        this.statusCourse
      ) {
        this.dialogCourse = true;
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('alert.alert_add_class_teacher') });
      } else if (
        this.cour.teacher.length > 0 &&
        !this.doubleCourse.name &&
        this.listStudent.filter(items => items.studentStatus == true).length == 0 &&
        !this.statusCourse
      ) {
        this.dialogCourse = true;
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('alert.alert_add_class_course') });
      } else if (this.listStudent.filter(items => items.studentStatus == true).length == 0 && this.statusCourse) {
        this.dialogCourse = true;
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('alert.alert_add_class_student') });
      } else if (this.listStudent.filter(items => items.studentStatus == true).length > 0 && !this.statusCourse) {
        this.dialogCourse = true;
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('alert.alert_add_class_status') });
      }
    },
    backTeacherTemp() {
      this.dialogCourse = false;
    },
    backEdit() {
      if (
        this.doubleCourse.name &&
        typeof this.form.courses[this.keycourses].teachers !== 'undefined' &&
        this.form.courses[this.keycourses].teachers.length > 0
      ) {
        this.cour.teacher = [];
        this.getTeacher();
        this.listStudent = [];
        this.statusCourse = '';
        this.students_edit = [];
        this.keycourses = null;
        this.$store.commit('SchoolClass/filterCourse', this.doubleCourse.courseId);
        this.getCourse();
        this.doubleCourse = {};
        this.dialogCourseEdit = false;
      } else {
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('alert.alert_add_class_teacher') });
        this.dialogCourseEdit = true;
      }
    },
    addBackTeacherTempEdit() {
      if (
        this.doubleCourse.name &&
        typeof this.form.courses[this.keycourses].teachers !== 'undefined' &&
        this.form.courses[this.keycourses].teachers.length > 0 &&
        this.listStudent.filter(items => items.studentStatus == true).length > 0
      ) {
        this.form.courses[this.keycourses].courseId = this.doubleCourse.courseId;
        this.form.courses[this.keycourses].name = this.doubleCourse.name;
        this.form.courses[this.keycourses].students = this.listStudent;
        this.form.courses[this.keycourses].status = this.statusCourse;
        this.$store.commit('SchoolClass/filterCourse', this.doubleCourse.courseId);
        this.cour.teacher = [];
        this.doubleCourse = {};
        this.listStudent = [];
        this.statusCourse = '';
        this.students_edit = [];
        this.keycourses = null;
        this.dialogCourseEdit = false;
        this.getTeacher();
      } else if (
        this.form.courses[this.keycourses].teachers.length > 0 &&
        this.listStudent.filter(items => items.studentStatus == true).length == 0
      ) {
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('alert.alert_add_class_student') });
        this.dialogCourseEdit = true;
      } else if (
        this.form.courses[this.keycourses].teachers.length == 0 &&
        this.listStudent.filter(items => items.studentStatus == true).length > 0
      ) {
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('alert.alert_add_class_teacher') });
        this.dialogCourseEdit = true;
      } else if (
        this.form.courses[this.keycourses].teachers.length == 0 &&
        this.listStudent.filter(items => items.studentStatus == true).length == 0
      ) {
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('alert.alert_add_class_status_Edit') });
        this.dialogCourseEdit = true;
      }
    },
    cancelViewStudent() {
      this.listStudent = [];
      this.dialogStudent = false;
    },
    addTeacher(teacherId, fullName) {
      this.$store.commit('SchoolClass/filterTeacher', teacherId);

      this.cour.teacher.push({
        teacherId,
        fullName,
        status: true
      });
    },
    addTeacherEdit(teacherId, fullName) {
      this.$store.commit('SchoolClass/filterTeacher', teacherId);

      this.form.courses[this.keycourses].teachers.push({
        teacherId,
        fullName,
        status: true
      });
    },
    backTeacher(data) {
      this.cour.teacher = this.cour.teacher.filter(prev => prev.teacherId !== data.teacherId);
      this.$store.commit('SchoolClass/backTeacher', data);
    },
    backTeacherEdit(data) {
      this.form.courses[this.keycourses].teachers = this.form.courses[this.keycourses].teachers.filter(prev => prev.teacherId !== data.teacherId);
      this.$store.commit('SchoolClass/backTeacher', data);
    },
    deleteItemCourse(data, item) {
      this.$store.commit('SchoolClass/backCourse', data);
      this.form.courses.splice(item, 1);
      this.getTeacher();
    },
    editItemCouse(item, key) {
      localStorage.removeItem('gradeId');
      this.getStudentsRefresh();
      this.keycourses = key;
      var i;
      for (i = 0; i < item.teachers.length; i++) {
        this.$store.commit('SchoolClass/filterTeacher', item.teachers[i].teacherId);
      }
      this.$store.commit('SchoolClass/backCourse', item);
      var hasil = Object.assign({
        courseId: item.courseId,
        name: item.name
      });

      var hasilteacher = Object.assign({
        teacher: item.teachers
      });
      this.listStudent = item.students;

      // var ids = new Set(this.students.map(d => d.studentId));
      // var merged = [...this.students, ...item.students.filter(d => !ids.has(d.studentId))];
      // console.info(merged);
      // this.students = merged;

      this.cour = hasilteacher;
      this.doubleCourse = hasil;
      this.statusCourse = item.status;
      this.dialogCourseEdit = true;
    },
    submit() {
      localStorage.removeItem('gradeId');
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return false;
      }

      this.loading = true;
      const payload = { ...(this.edit ? { id: this.$route.params.id } : null), ...this.form };

      this.$store
        .dispatch(`SchoolClass/${this.edit ? 'update' : 'save'}`, payload)
        .then(() => this.$router.push({ name: this.edit ? 'SchoolClassSuccessUpdate' : 'SchoolClassSuccess' }))
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loading = false));
    },
    backToList() {
      localStorage.removeItem('gradeId');
      this.$router.push({ name: 'SchoolClassIndex' });
    }
  },
  created() {
    this.getCourse();
    this.getStudents();
    this.getTeacher();
    this.getLevel();

    if (this.$route.params.id) {
      this.getData();
      this.getStudentsRefreshEdit();
      this.edit = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.move-list {
  &-title {
    background: #00bf63;
    color: #fff;
    font-family: Montserrat;
    font-weight: 800;
    border-radius: 8px 8px 0 0;
    padding: 10px;
    width: 100%;
  }

  &-content {
    border: 1px solid #d8d8d8;
    border-radius: 0 0 8px 8px;
    padding: 10px;
    overflow: scroll;
    overflow-x: hidden;
    width: 100%;
    height: 18em;
    line-height: 2em;

    ul {
      list-style: none;
      padding: 0;

      li {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #d8d8d8;
        padding: 10px 15px;
        align-items: center;

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}

.move-listatas {
  &-titleatas {
    background: #00bf63;
    color: #fff;
    font-family: Montserrat;
    font-weight: 800;
    border-radius: 8px 8px 0 0;
    padding: 10px;
    width: 100%;
  }

  &-contentatas {
    border: 1px solid #d8d8d8;
    border-radius: 0 0 8px 8px;
    padding: 10px;
    overflow: scroll;
    overflow-x: hidden;
    width: 100%;
    height: 25em;
    line-height: 2em;

    ul {
      list-style: none;
      padding: 0;

      li {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #d8d8d8;
        padding: 10px 15px;
        align-items: center;

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
.scroll {
  overflow: scroll;
  overflow-x: hidden;
  height: 20em;
}
</style>
